import React, { useRef } from 'react';

import chevronDownSmallTokens from '@amzn/meridian-tokens/base/icon/chevron-down-small';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import PlacementUpdateMenu from 'src/components/shared/placementUpdateMenu';
import useOpenCloseState from 'src/hooks/useOpenCloseState';
import type { AssociateProfilePlacement } from 'src/services/associateProfile/types';
import type { RestrictionListParentTask, RestrictionListTask } from 'src/utils/restrictionUtilsLegacy';

interface ActionsProps {
  placement: AssociateProfilePlacement;
  regionTasks: (RestrictionListTask | RestrictionListParentTask)[];
  onTransferSuccess?: VoidFunction;
}

const UpdateActionMenu = ({ placement, regionTasks, onTransferSuccess }: ActionsProps) => {
  const updateLinkRef = useRef<HTMLButtonElement>(null);
  const { isOpen: isUpdateMenuOpen, open: openUpdateMenu, close: closeUpdateMenu } = useOpenCloseState();

  return (
    <>
      <Button type="link" ref={updateLinkRef} onClick={openUpdateMenu}>
        Update <Icon tokens={chevronDownSmallTokens} />
      </Button>
      <PlacementUpdateMenu
        isMenuOpen={isUpdateMenuOpen}
        closeMenu={closeUpdateMenu}
        placementId={placement.accommodationId.toString()}
        anchorRef={updateLinkRef}
        accommodationStatusesForSite={[]}
        managerAlias={placement.managerAlias}
        fc={placement.fc}
        accommodationType={placement.accommodationType}
        placementStatus={placement.accommodationStatus}
        workRestrictions={placement.workRestrictions}
        modifiedShiftLength={placement.modifiedShiftLength}
        externalCaseId={placement.externalCaseId}
        regionTasks={regionTasks}
        onTransferSuccess={onTransferSuccess}
      />
    </>
  );
};

export default UpdateActionMenu;
